import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { catchError, map, of } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const navCtrl = inject(NavController);
  const redirectToLogin = () => {
    void navCtrl.navigateRoot('/login', {
      animated: true,
      replaceUrl: true,
    });
    return false;
  };

  return authService.isAuthenticated$().pipe(
    map(isAuthenticated => isAuthenticated || redirectToLogin()),
    catchError(() => of(redirectToLogin()))
  );
};
